import { Avatar, IconButton, IconButtonProps } from "@mui/material";
import { User } from "User/entity";

type AvatarIconProps = IconButtonProps & {
  openPopover: (event: React.MouseEvent<HTMLButtonElement>) => void;
  user: User;
};

export const AvatarIcon = ({
  openPopover,
  sx,
  user,
  ...other
}: AvatarIconProps) => {
  return (
    <IconButton
      onClick={openPopover}
      sx={{
        background: (theme) =>
          `conic-gradient(${theme.vars.palette.primary.light}, ${theme.vars.palette.warning.light}, ${theme.vars.palette.primary.light})`,
        height: 40,
        p: "2px",
        width: 40,
        ...sx,
      }}
      {...other}
    >
      <Avatar
        alt={user.name}
        src={`/assets/images/avatar/${user.id}.jpg`}
        sx={{ height: 1, width: 1 }}
      >
        {user.name}
      </Avatar>
    </IconButton>
  );
};
